import axios from "axios";
import { loadTossPayments } from "@tosspayments/payment-sdk";

const clientKey = "test_ck_D5GePWvyJnrK0W0k6q8gLzN97Eoq";
// const https = require("https");

class AdminRequester {
  instance = null;

  constructor() {
    axios.defaults.withCredentials = true;
    this.instance = axios.create({
      baseURL: `${process.env.REACT_APP_ORIGIN}/admin`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // httpsAgent: new https.Agent({ rejectUnauthorized: false }),
      origin: process.env.REACT_APP_ORIGIN,
      withCredentials: true,
    });
    this.instance.interceptors.response.use(
      (response) => {
        return response;
      },
      async (error) => {
        if (
          error.response.status === 401 &&
          error.response.data === "Unauthorized"
        ) {
          const isAdmin = window.location.pathname.includes("admin");
          if (
            window.location.pathname !==
            (isAdmin ? "/admin/login" : "/vendor/login")
          )
            window.location.href = isAdmin ? "/admin/login" : "/vendor/login";
        }
        return Promise.reject(error);
      }
    );
    this.instance.interceptors.request.use(
      (config) => {
        return config;
      },
      async (error) => {
        return Promise.reject(error);
      }
    );
  }

  // setAuthTokenHeader(token) {
  //   this.instance = axios.create({
  //     baseURL: `${process.env.REACT_APP_ORIGIN}/admin`,
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //       Authorization: token,
  //     },
  //     origin: process.env.REACT_APP_ORIGIN,
  //     withCredentials: true,
  //   });
  // }

  async get(url, data) {
    let instance = this.instance;
    let result = "";
    let params = "?" + new URLSearchParams(data).toString();
    try {
      return new Promise(function(resolve, reject) {
        instance
          .get(url + params)
          .then((res) => {
            result = res.data;
          })
          .catch((error) => {
            if (error.response) {
              result = error.response.data;
              // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
              // if (error.response.status === 401) {
              //   // invalid token
              //   result.code = error.response.status;
              // } else {
              // }
            } else if (error.request) {
              // 요청이 이루어 졌으나 응답을 받지 못했습니다.
              // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
              // Node.js의 http.ClientRequest 인스턴스입니다.
            } else {
              // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            }
          })
          .finally(() => {
            resolve(result);
          });
      });
    } catch (e) {}
  }
  async delete(url, data) {
    let instance = this.instance;
    let result = "";
    let params = "?" + new URLSearchParams(data).toString();
    try {
      return new Promise(function(resolve, reject) {
        instance
          .delete(url + params)
          .then((res) => {
            result = res.data;
          })
          .catch((error) => {
            if (error.response) {
              result = error.response.data;
              // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
              // if (error.response.status === 401) {
              //   // invalid token
              //   result.code = error.response.status;
              // } else {
              // }
            } else if (error.request) {
              // 요청이 이루어 졌으나 응답을 받지 못했습니다.
              // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
              // Node.js의 http.ClientRequest 인스턴스입니다.
            } else {
              // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            }
          })
          .finally(() => {
            resolve(result);
          });
      });
    } catch (e) {}
  }

  async post(url, data) {
    let instance = this.instance;
    let result = "";
    try {
      return new Promise(function(resolve, reject) {
        instance
          .post(url, JSON.stringify(data))
          .then((res) => {
            result = res.data;
          })
          .catch((error) => {
            if (error.response) {
              result = error.response.data;
              // if (error.response.status === 401) {
              //   // invalid token
              //   result.code = error.response.status;
              // } else {
              // }
            } else if (error.request) {
            } else {
            }
          })
          .finally(() => {
            resolve(result);
          });
      });
    } catch (e) {}
  }
  async Login(data, callback) {
    callback(await this.post(`auth`, data));
  }
  // user
  async getCurrentUser(callback) {
    callback(await this.get(`auth`));
  }
  async getUsers(data, callback) {
    if (callback) callback(await this.get(`users`, data));
    else return await await this.get(`users`, data);
  }
  async createUser(data, callback) {
    if (callback) callback(await this.post(`users`, data));
    else return await this.post(`users`, data);
  }
  async updateUser(id, data, callback) {
    if (callback) callback(await this.post(`users/${id}`, data));
    else return await this.post(`users/${id}`, data);
  }
  async isExistEmail(email, callback) {
    if (callback) callback(await this.get(`/auth/${email}`));
    else return await this.get(`/auth/${email}`);
  }
  // store
  async getStores(data, callback) {
    if (callback) callback(await this.get(`stores`, data));
    else return await await this.get(`stores`, data);
  }
  async createStore(data, callback) {
    if (callback) callback(await this.post(`stores`, data));
    else return await this.post(`stores`, data);
  }
  // 주문서
  async getOrders(data, callback) {
    callback(await this.get(`orders`, data));
  }
  async getOrder(id, data, callback) {
    if (callback) callback(await this.get(`orders/${id}`, data));
    else return await this.get(`orders/${id}`, data);
  }
  async getOrderStatus(data, callback) {
    if (callback) callback(await this.get(`orders/status`, data));
    else return await this.get(`orders/status`, data);
  }
  async createFulfillment(id, data, callback) {
    callback(await this.post(`orders/${id}/fulfillment`, data));
  }
  async shipFulfillment(id, data, callback) {
    callback(await this.post(`orders/${id}/shipment`, data));
  }
  async updateOrderStatus(id, data, callback) {
    if (callback) callback(await this.post(`orders/${id}/status`, data));
    else return await this.post(`orders/${id}/status`, data);
  }
  async editOrder(orderId, data, callback) {
    if (callback) callback(await this.post(`orders/${orderId}/edit`, data));
    else return await this.post(`orders/${orderId}/edit`, data);
  }
  async Logout(callback) {
    callback(await this.delete(`auth`));
  }
  async getStatistic(data, callback) {
    callback(await this.get(`statistic`, data));
  }
  async getLayout(data, callback) {
    callback(await this.get(`layout`, data));
  }
  async postLayout(data, callback) {
    callback(await this.post(`layout`, data));
  }
  async deleteLayout(data, callback) {
    callback(await this.delete(`layout`, data));
  }
  async getProducts(data, callback) {
    if (callback) callback(await this.get(`products`, data));
    else return await this.get(`products`, data);
  }
  async getProduct(id, data, callback) {
    if (callback) callback(await this.get(`products/${id}`, data));
    else return await this.get(`products/${id}`, data);
  }
  async getProductStatus(data, callback) {
    if (callback) callback(await this.get(`products/status`, data));
    else return await this.get(`products/status`, data);
  }
  async postProduct(data, callback) {
    callback(await this.post(`products`, data));
  }
  async updateProduct(id, data, callback) {
    if (callback) callback(await this.post(`products/${id}`, data));
    else return await this.post(`products/${id}`, data);
  }
  async deleteProduct(id, callback) {
    if (callback) callback(await this.delete(`products/${id}`));
    else return await this.delete(`products/${id}`);
  }
  async postProductOption(id, data, callback) {
    callback(await this.post(`products/${id}/options`, data));
  }
  async deleteProductOption(id, option_id, data, callback) {
    callback(await this.delete(`products/${id}/options/${option_id}`, data));
  }
  async postVariants(id, data, callback) {
    if (callback) callback(await this.post(`products/${id}/variants`, data));
    else return await this.post(`products/${id}/variants`, data);
  }
  async updateVariants(product_id, data, callback) {
    if (callback)
      callback(await this.post(`products/${product_id}/variants/status`, data));
    else return await this.post(`products/${product_id}/variants/status`, data);
  }
  async updateVariant(product_id, variant_id, data, callback) {
    if (callback)
      callback(
        await this.post(`products/${product_id}/variants/${variant_id}`, data)
      );
    else
      return await this.post(
        `products/${product_id}/variants/${variant_id}`,
        data
      );
  }
  async deleteVariant(id, variant_id, callback) {
    if (callback)
      callback(await this.delete(`products/${id}/variants/${variant_id}`));
    else return await this.delete(`products/${id}/variants/${variant_id}`);
  }
  async getVariantStatus(data, callback) {
    if (callback) callback(await this.get(`variants/status`, data));
    else return await this.get(`variants/status`, data);
  }
  async postVariantStatus(data, callback) {
    if (callback) callback(await this.post(`variants/status`, data));
    else return await this.post(`variants/status`, data);
  }
  async getVariants(data, callback) {
    if (callback) callback(await this.get(`variants`, data));
    else return await this.get(`variants`, data);
  }
  async getCategories(data, callback) {
    callback(await this.get(`product-categories`, data));
  }
  async postCategories(data, callback) {
    callback(await this.post(`product-categories`, data));
  }
  async deleteCategory(id, callback) {
    callback(await this.delete(`product-categories/${id}`));
  }
  async getPromotions(data, callback) {
    callback(await this.get(`promotions`, data));
  }
  async postEvent(data, callback) {
    callback(await this.post(`events`, data));
  }
  async updateEvent(id, data, callback) {
    callback(await this.post(`events/${id}`, data));
  }
  async postDiscount(data, callback) {
    callback(await this.post(`discounts`, data));
  }
  async updateDiscount(id, data, callback) {
    callback(await this.post(`discounts/${id}`, data));
  }
  async updateDiscountCondition(id, condition_id, data, callback) {
    callback(
      await this.post(`discounts/${id}/conditions/${condition_id}/batch`, data)
    );
  }
  async getRegions(callback) {
    if (callback) callback(await this.get(`regions`));
    else return await this.get(`regions`);
  }
  async getDiscountStatus(data, callback) {
    if (callback) callback(await this.get(`discounts/status`, data));
    else return await this.get(`discounts/status`, data);
  }
  async postDiscountStatus(data, callback) {
    if (callback) callback(await this.post(`discounts/status`, data));
    else return await this.post(`discounts/status`, data);
  }
  async getCustomerStatus(data, callback) {
    if (callback) callback(await this.get(`customers/status`, data));
    else return await this.get(`customers/status`, data);
  }
  async updateCustomer(id, data, callback) {
    if (callback) callback(await this.post(`customers/${id}`, data));
    else return await this.post(`customers/${id}`, data);
  }
  async getCustomerOrder(customer_id, data, callback) {
    if (callback)
      callback(await this.get(`customers/${customer_id}/orders`, data));
    else return await this.get(`customers/${customer_id}/orders`, data);
  }
  async getArticles(data, callback) {
    if (callback) callback(await this.get(`articles`, data));
    else return await this.get(`articles`, data);
  }
  async getArticleStatus(data, callback) {
    if (callback) callback(await this.get(`articles/status`, data));
    else return await this.get(`articles/status`, data);
  }
  async createArticle(data, callback) {
    if (callback) callback(await this.post(`articles`, data));
    else return await this.post(`articles`, data);
  }
  async updateArticle(id, data, callback) {
    if (callback) callback(await this.post(`articles/${id}`, data));
    else return await this.post(`articles/${id}`, data);
  }
  async deleteArticle(id, callback) {
    if (callback) callback(await this.delete(`articles/${id}`));
    else return await this.delete(`articles/${id}`);
  }
  async getBoards(data, callback) {
    if (callback) callback(await this.get(`boards`, data));
    else return await this.get(`boards`, data);
  }
  async isBoardExists(name, data, callback) {
    if (callback) callback(await this.get(`boards/exists/${name}`, data));
    else return await this.get(`boards/exists/${name}`, data);
  }
  async postBoardStatus(data, callback) {
    if (callback) callback(await this.post(`boards/status`, data));
    else return await this.get(`boards/status`, data);
  }
  async getLineItems(data, callback) {
    if (callback) callback(await this.get(`boards`, data));
    else return await this.get(`boards`, data);
  }
  async getChatrooms(data, callback) {
    if (callback) callback(await this.get(`chatroom`, data));
    else return await this.get(`chatroom`, data);
  }
  async getChatroomStatus(data, callback) {
    if (callback) callback(await this.get(`chatroom/status`, data));
    else return await this.get(`chatroom/status`, data);
  }
  async getChatroom(id, data, callback) {
    if (callback) callback(await this.get(`chatroom/${id}`, data));
    else return await this.get(`chatroom/${id}`, data);
  }
  async getChat(id, data, callback) {
    if (callback) callback(await this.get(`chatroom/${id}/chat`, data));
    else return await this.get(`chatroom/${id}/chat`, data);
  }
  async getLogs(data, callback) {
    if (callback) callback(await this.get(`logs`, data));
    else return await this.get(`logs`, data);
  }
  async createLog(data, callback) {
    if (callback) callback(await this.post(`logs`, data));
    else return await this.post(`logs`, data);
  }
}

export default AdminRequester;
